const { BASE_URL } = require("./client");

const GET_VOLUNTEER_DATA = BASE_URL + "/api/volunteer";
module.exports = {
  GET_VOLUNTEER_DATA,
};
